var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"Menu"}},[_c('MenuTop',{staticClass:"d-none d-sm-block"}),_c('MainMenu')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }